import PropTypes from "prop-types";
import cn from "classnames";

const Button = (props) => {
  const {
    className,
    variant,
    size,
    block,
    type,
    href,
    target,
    tabIndex,
    onClick,
    disabled,
    icon,
    children,
    dataId = "",
    onMouseEnter,
    onMouseLeave,
    ariaHidden,
    form,
    style,
  } = props;
  const classNames = cn("a-btn", className, `a-btn--${variant}`, {
    "a-btn--small": size === "small",
    "a-btn--block": block,
    "a-btn--icon": icon !== "",
  });

  const _ariaHidden = ariaHidden !== "" ? { "aria-hidden": ariaHidden } : {};

  return (
    <>
      {type === "link" && (
        <a
          {...props}
          href={href}
          className={classNames}
          target={target}
          tabIndex={tabIndex}
          onClick={onClick}
          data-test-id={dataId}
        >
          {icon !== "" ? <h2>no icon</h2> : children}
        </a>
      )}

      {(type === "button" || type === "submit") && (
        <button
          style={style}
          {..._ariaHidden}
          type={type}
          className={classNames}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          onClick={onClick}
          tabIndex={tabIndex}
          disabled={disabled}
          data-test-id={dataId}
          form={form}
        >
          {icon !== "" ? <h2>no icon</h2> : children}
        </button>
      )}
    </>
  );
};

Button.propTypes = {
  className: PropTypes.string,
  size: PropTypes.oneOf(["", "small"]),
  block: PropTypes.bool,
  variant: PropTypes.oneOf([
    "primary",
    "primary-white",
    "secondary",
    "secondary-white",
    "dark",
  ]),
  type: PropTypes.oneOf(["button", "submit", "link-dom", "link"]),
  href: PropTypes.string,
  target: PropTypes.string,
  tabIndex: PropTypes.string,
  icon: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  children: PropTypes.node,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  ariaHidden: PropTypes.string,
  form: PropTypes.string,
};

Button.defaultProps = {
  className: "",
  variant: "primary",
  size: "",
  block: false,
  type: "button",
  href: "",
  target: "_self",
  tabIndex: "0",
  icon: "",
  onClick: () => {},
  disabled: false,
  children: "",
  onMouseEnter: () => {},
  onMouseLeave: () => {},
  ariaHidden: "",
  form: "",
};

export default Button;
